import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button, RelationSelect } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {
	@observable records = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.records = await store.model.Division.find({
			include: [{ relation: 'group', scope: { fields: { id: true, name: true } } }],
			order: 'id asc',
		});
	};

	create = () => this.props.history.push('/admin/divisions/create');

	render() {
		if (!this.records) return '...';

		return (
			<>
				<p>
					<Button className="btn-primary" onClick={this.create}>
						Создать
					</Button>
				</p>
				<Table records={this.records} rootPath="/admin">
					{/*<Column width={50} property="id" label="id" />*/}
					<Column width={50} property="number" label="Номер" />
					<Column width={400} property="name" label="Наименование" />
					<Column relation="group" property="name" label="Группа" />
				</Table>
			</>
		);
	}
}
